import React, { useEffect, useState } from "react";
import { formatDate, getTimeDeltaHuman } from "../utils/Functions";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import { Button, Typography, InputLabel, makeStyles } from "@material-ui/core";
import { IconButton } from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import DisabledByDefaultOutlinedIcon from '@mui/icons-material/DisabledByDefaultOutlined';
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";


const useStyles = makeStyles(theme => ({
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        '& .MuiFormLabel-root.Mui-disabled': {
            color: 'red',
        },
        '& .MuiPaper-root': {
            backgroundColor: '#333333',
        }
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#1be01e',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#5861fc',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
        '&:hover': {
            backgroundColor: '#fc0d31',
            color: '#333333',
        },
        '&:disabled': {
            color: '#CCCCCC',
        }
    },
    dialogWidget: {
        margin: '5px',
        color: '#CCCCCC',
        justify: 'flex',
        alignItems: 'center',
    },
    inputRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        verticalAlign: 'baseline',
    },
    accordian: {
        color: '#EEE',
        justifyContent: "unset",
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))

export default function ForensicsDialog({ open, onClose, formData }) {
    const classes = useStyles()
    let title = 'Forensics'

    if (formData.pk) {
        title = 'Download Forensics: ' + formData.pk
    } else {
        title = 'Error loading forensics bundle'
    }

    function getDownloadIcon(name, url) {
        if (name !== '' && url !== '') {
            console.log(url)
            return (
                <CloudDownloadOutlinedIcon color={"primary"}
                       onClick={() => window.open(url, '_blank')} disabled={false} />
            )
        }
        else {
            return (
                <CloudDownloadOutlinedIcon color={"disabled"} disabled={true} />
            )
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{ width: 500 }}
            fullWidth={true}
            maxWidth="sm"
        >
            <DialogTitle className={classes.dialogTitleBar}>
                {title}
                <IconButton><HelpOutlineOutlinedIcon /></IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialog}>
                <DialogContentText className={classes.dialog} component={'span'}>
                    <Grid container spacing={2}>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Hostname</InputLabel>
                        </Grid>
                        <Grid item xs={7}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>{formData.hostname}</Typography>
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>IP Address</InputLabel>
                        </Grid>
                        <Grid item xs={7} className={classes.inputRow}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>{formData.ip}</Typography>
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Command Line</InputLabel>
                        </Grid>
                        <Grid item xs={7} className={classes.inputRow}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>{formData.command_line}</Typography>
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Process Image</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.image, formData.image_url)}
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Memory Dump</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.memdump, formData.memdump_url)}
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Open File handles</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.file_handles, formData.file_handles_url)}
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Running Processes</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.processes, formData.processes_url)}
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Network Connections</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.network_conns, formData.network_conns_url)}
                        </Grid>
                        <Grid item xs={4} className={classes.inputRow}>
                            <InputLabel className={classes.dialog}>Registry Keys</InputLabel>
                        </Grid>
                        <Grid item xs={2} className={classes.inputRow}>
                            {getDownloadIcon(formData.registry_keys, formData.registry_keys_url)}
                        </Grid>
                        <Grid item xs={11} className={classes.inputRow}></Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={11}>
                            <Typography variant='subtitle2' className={classes.dialogWidget} component={'span'}>
                                Created: {formatDate(formData.created ? formData.created : new Date())}  ({getTimeDeltaHuman(formData.created ? formData.created : new Date())})
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContentText>
                <DialogActions>
                    <Button className={classes.dialogNeutral} onClick={() => { onClose() }} variant="contained" startIcon={<DisabledByDefaultOutlinedIcon />}>
                        CLOSE
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
}
